import { FormattedMessage } from "react-intl";
import ChatIcon from "@mui/icons-material/Chat";
import PhoneIcon from "@mui/icons-material/Phone";
import { makeStyles } from "@mui/styles";
import { MailToLink, TelLink } from "../../../common/Links";
import DirectMessageRowItem from "../../../UserDetails/AccountSettingsModal/AboutSection/DirectMessageRowItem";
import GroupRowItem from "../../../UserDetails/AccountSettingsModal/AboutSection/GroupRowItem";
import FaIcon from "./FaIcon";
import RowItem from "./RowItem";

const useStyles = makeStyles(() => ({
  icon: {
    fontSize: 18,
    color: "rgba(0,0,0,0.42)",
  },
}));

const ColumnOne = ({ userDetails }) => {
  const classes = useStyles();

  const {
    company,
    directMessage,
    email,
    groupBreadcrumbs, // !!!
    mainEducation,
    mobile,
    phone,
    userGroupBreadCrumb, // !!!
    visibilitySettings, //Kan bli null om vi anv�nder den fr�n SiteUsersTable (m.fl)
    displaySettings, //�r null n�r vi anv�nder den fr�n anv�ndarens f�rhandsgranskning
  } = userDetails || {};

  const breadcrumbs = (groupBreadcrumbs || userGroupBreadCrumb); // TODO

  const displayDirectMessage =
    (displaySettings && displaySettings["directMessage"]) ||
    (visibilitySettings && visibilitySettings["directMessage"] === "PUBLIC");

  return (
    <>
      {company && (
        <RowItem
          title={
            <span>
              <FormattedMessage id="account.workingOn" /> {company}
            </span>
          }
          subTitle={<FormattedMessage id="settings.theUsersCompany" />}
          leftIcon={<FaIcon icon="fas fa-briefcase" />}
        />
      )}
      {breadcrumbs && (
        <GroupRowItem
          userGroupBreadCrumb={breadcrumbs}
          leftIcon={<FaIcon icon="fas fa-sitemap" />}
        />
      )}
      {email && (
        <RowItem
          title={<MailToLink email={email} />}
          subTitle={<FormattedMessage id="settings.email" />}
          leftIcon={<FaIcon icon="far fa-envelope" />}
        />
      )}
      {mainEducation && (
        <RowItem
          name="mainEducation"
          visibilitySettings={visibilitySettings}
          displaySettings={displaySettings}
          title={mainEducation}
          subTitle={<FormattedMessage id="settings.professionalDegrees" />}
          leftIcon={<FaIcon icon="fas fa-graduation-cap" />}
        />
      )}
      {phone && (
        <RowItem
          name="phone"
          visibilitySettings={visibilitySettings}
          displaySettings={displaySettings}
          title={<TelLink tel={phone} />}
          subTitle={<FormattedMessage id="settings.phone" />}
          leftIcon={<PhoneIcon className={classes.icon} />}
        />
      )}
      {mobile && (
        <RowItem
          name="mobile"
          visibilitySettings={visibilitySettings}
          displaySettings={displaySettings}
          title={<TelLink tel={mobile} />}
          subTitle={<FormattedMessage id="settings.mobile" />}
          leftIcon={<PhoneIcon className={classes.icon} />}
        />
      )}
      {displayDirectMessage && (
        <DirectMessageRowItem hideActionButtons
          title={directMessage}
          subTitle={<FormattedMessage id="settings.instantMessage" />}
          leftIcon={<ChatIcon className={classes.icon} sx={{ marginTop: "3px" }} />}
        />
      )}
    </>
  );
};

export default ColumnOne;
